export const emptyToastMessage = {
    title: '',
    desc: '',
    type: '',
};